import PeopleSelector from './PeopleSelector';

customElements.define('people-selector', PeopleSelector);
